module.exports = require('./helpers/bundle-url').getBundleURL('8kqgc') + "apple-store.bb76d302.png";